import React, { Component } from "react";
import { connect } from "react-redux";
import { faBell } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Badge from "@material-ui/core/Badge";
import SingleNotification from "./SingleNotification";
import AxiosConfig from "axiosConfig";
import Logo from "../../../../site_media/images/menu_Home.png";

class Notifications extends Component {
  constructor(props) {
    super(props);
    this.state = {
      notifications: null,
      count:null
    };
  }

  componentDidMount() {
    this.fetchNotifications(this);
  }
  fetchNotifications = (obj) => {
    AxiosConfig.get('/notifications/all/')
      .then(function (res) {
        if (res.status === 200) {
          obj.setState({
            notifications: res.data.results,
            count:res.data.unread
          });
        }
      })
      .catch((err) => {
      });
  };

  render() {
    return (
      <div className="header__settings">
        <div className="setting-icon">
          <Badge
            badgeContent={this.state.notifications && this.state.count}
            max={10}
            color="error"
            size="small"
          >
            <FontAwesomeIcon icon={faBell} color="#A2C4C6" size="lg" />
          </Badge>
          <div className="settings-dropdown notification-container">
            {this.state.notifications && this.state.notifications.length > 0
              ? this.state.notifications.map((n) =>
                  n.action_type === "JOINED_KATAMUNDI" ? (
                    <SingleNotification
                      label="Welcome to Katamundi!"
                      buttonText="Check out our blog!"
                      buttonLink="https://katamundi.org"
                      isTargetBlank={true}
                      imgSrc={Logo}
                      notifiedOn={n.created_at}
                      isRead={n.is_read}
                      ID={n.id}
                    />
                  ) : n.action_type === "CHILD_PARENT_FRIEND" ? (
                    <SingleNotification
                      label={"You are now friends with " + n.friend.full_name}
                      buttonText="View"
                      buttonLink={"/friends"}
                      imgSrc={n.friend.user_photo}
                      notifiedOn={n.created_at}
                      isRead={n.is_read}
                      ID={n.id}
                    />
                  ) : n.action_type === "PARENT_CHILD_FRIEND" ? (
                    <SingleNotification
                      label={"You are now friends with " + n.friend.full_name}
                      buttonText="View"
                      buttonLink={"/friends"}
                      imgSrc={n.friend.user_photo}
                      notifiedOn={n.created_at}
                      isRead={n.is_read}
                      ID={n.id}
                    />
                  ) : n.action_type === "FRIEND_RECEIVED_REQUEST" ? (
                    <SingleNotification
                      label={
                        "You have a new friend invitation from " +
                        n.friend.full_name
                      }
                      buttonText="View"
                      buttonLink={"/friends"}
                      imgSrc={n.friend.user_photo}
                      notifiedOn={n.created_at}
                      isRead={n.is_read}
                      ID={n.id}
                    />
                  ) : n.action_type === "FRIEND_ACCEPTED_REQUEST" ? (
                    <SingleNotification
                      label={
                        n.friend.full_name +
                        " has accepted your friend invitation"
                      }
                      buttonText="View"
                      buttonLink={"/friends"}
                      imgSrc={n.friend.user_photo}
                      notifiedOn={n.created_at}
                      isRead={n.is_read}
                      ID={n.id}
                    />
                  ) : n.action_type === "CHILD_RECEIVED_FRIEND_REQUEST" ? (
                    <SingleNotification
                      label={
                        n.friend.full_name +
                        " wants to send a friend invitation to " +
                        n.child.full_name
                      }
                      buttonText="View"
                      buttonLink={"/manage-child-tribe"}
                      imgSrc={n.friend.user_photo}
                      notifiedOn={n.created_at}
                      isRead={n.is_read}
                      ID={n.id}
                    />
                  ) : n.action_type === "CHILD_SENT_FRIEND_REQUEST" ? (
                    <SingleNotification
                      label={
                        n.child.full_name +
                        " wants to send a friend invitation to " +
                        n.friend.full_name
                      }
                      buttonText="View"
                      buttonLink={"/manage-child-tribe"}
                      imgSrc={n.child.user_photo}
                      notifiedOn={n.created_at}
                      isRead={n.is_read}
                      ID={n.id}
                    />
                  ) : n.action_type === "FOLLOWING" ? (
                    <SingleNotification
                      label={
                        n.friend.full_name +
                        " has joined "+ n.group.name+" group " 
                       
                      }
                      buttonText="View"
                      buttonLink={
                        "/groups/view/" + n.group.id + "/" + n.group.name
                      }
                      imgSrc={n.friend.user_photo}
                      notifiedOn={n.created_at}
                      isRead={n.is_read}
                      ID={n.id}
                    />
                  ) : n.action_type === "GROUP_POST" ? (
                    <SingleNotification
                      label={
                        n.friend.full_name +
                        " has posted on "+ n.group.name +" group " 
                        
                      }
                      buttonText="View"
                      buttonLink={
                        "/groups/view/" + n.group.id + "/" + n.group.name
                      }
                      imgSrc={n.friend.user_photo}
                      notifiedOn={n.created_at}
                      isRead={n.is_read}
                      ID={n.id}
                    />
                  ) : n.action_type === "GROUP_RECEIVED_REQUEST" ? (
                    <SingleNotification
                      label={
                        n.friend.full_name +
                        " has sent you an invitation to join " +
                        n.group.name +
                        " group"
                      }
                      buttonText="View"
                      buttonLink={"/groups"}
                      imgSrc={n.friend.user_photo}
                      notifiedOn={n.created_at}
                      isRead={n.is_read}
                      ID={n.id}
                    />
                  ) : n.action_type === "GROUP_REQUEST_ACCEPTED" ? (
                    <SingleNotification
                      label={
                        "You are now a member of " + n.group.name + " group"
                      }
                      buttonText="View"
                      buttonLink={"/groups"}
                      imgSrc={n.user.user_photo}
                      notifiedOn={n.created_at}
                      isRead={n.is_read}
                      ID={n.id}
                    />
                  ) : n.action_type === "CHILD_SENT_GROUP_REQUEST" ? (
                    <SingleNotification
                      label={
                        n.child.full_name +
                        " wants  to join " +
                        n.group.name +
                        " group"
                      }
                      buttonText="View"
                      buttonLink={"/manage-child-tribe"}
                      imgSrc={n.child.user_photo}
                      notifiedOn={n.created_at}
                      isRead={n.is_read}
                      ID={n.id}
                    />
                  ) : n.action_type === "CHILD_RECEIVED_GROUP_REQUEST" ? (
                    <SingleNotification
                      label={
                        n.friend.full_name +
                        " wants to send an invitation to " +
                        n.child.full_name +
                        " to join " +
                        n.group.name +
                        " group"
                      }
                      buttonText="View"
                      buttonLink={"/manage-child-tribe"}
                      imgSrc={n.friend.user_photo}
                      notifiedOn={n.created_at}
                      isRead={n.is_read}
                      ID={n.id}
                    />
                  ) : n.action_type === "RECEIVED_PROJECT_INVITATION" ? (
                    <SingleNotification
                      label={
                        n.friend.full_name +
                        " has sent you an invitation to join " +
                        n.project.name +
                        " project"
                      }
                      buttonText="View"
                      buttonLink={"/projects"}
                      imgSrc={n.friend.user_photo}
                      notifiedOn={n.created_at}
                      isRead={n.is_read}
                      ID={n.id}
                    />
                  ) : n.action_type === "RECEIVED_GROUP_JOIN_REQUEST" ? (
                    <SingleNotification
                      label={
                        n.friend.user_name +
                        " wants to join " +
                        n.group.name +
                        " group"
                      }
                      buttonText="View"
                      buttonLink={
                        "/groups/view/" + n.group.id + "/" + n.group.name
                      }
                      imgSrc={n.friend.user_photo}
                      notifiedOn={n.created_at}
                      isRead={n.is_read}
                      ID={n.id}
                    />
                  ) : n.action_type === "FRIEND_LIKED_ON_POST" ? (
                    <SingleNotification
                      label={
                        n.friend.full_name +
                        " has reacted on your post with " +
                        n.post_reaction.reaction.name
                      }
                      buttonText="View"
                      buttonLink={"/feeds/" + n.post.id}
                      imgSrc={n.friend.user_photo}
                      notifiedOn={n.created_at}
                      isRead={n.is_read}
                      ID={n.id}
                    />
                  ) : n.action_type === "FRIEND_COMMENTED_ON_POST" ? (
                    <SingleNotification
                      label={n.friend.full_name + " has commented on your post"}
                      buttonText="View"
                      buttonLink={"/feeds/" + n.post.id}
                      imgSrc={n.friend.user_photo}
                      notifiedOn={n.created_at}
                      isRead={n.is_read}
                      ID={n.id}
                    />
                  ) : n.action_type === "MUTIPLE_COMMENT" ? (
                    <SingleNotification
                      label={n.friend.full_name + " also commented on the post"}
                      buttonText="View"
                      buttonLink={"/feeds/" + n.post.id}
                      imgSrc={n.friend.user_photo}
                      notifiedOn={n.created_at}
                      isRead={n.is_read}
                      ID={n.id}
                    />
                  ) : n.action_type === "MULTIPLE_LIKE" ? (
                    <SingleNotification
                      label={
                        n.friend.full_name +
                        " also reacted on the post with " +
                        n.post_reaction.reaction.name
                      }
                      buttonText="View"
                      buttonLink={"/feeds/" + n.post.id}
                      imgSrc={n.friend.user_photo}
                      notifiedOn={n.created_at}
                      isRead={n.is_read}
                      ID={n.id}
                    />
                  ) 
                  : null
                )
              : null}
          </div>
        </div>
      </div>
    );
  }
}

export default connect()(Notifications);
